import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

import { AFTER_ISSUED_FROM_WIDTH, QUANTITY_TO_TREATMENT_DAYS_GAP } from '../../prescriptionGrid.constants';

export const StyledSentStandardPrescriptionGrid = styled.div`
   ${basicBodyTextStyle};
`;

StyledSentStandardPrescriptionGrid.displayName = 'StyledSentStandardPrescriptionGrid';

export const StyledSentStandardPrescriptionRightColumn = styled.div`
   display: flex;
   flex-direction: row;
   align-items: flex-start;
   gap: ${QUANTITY_TO_TREATMENT_DAYS_GAP};
   min-width: ${AFTER_ISSUED_FROM_WIDTH};
`;

StyledSentStandardPrescriptionRightColumn.displayName = 'StyledSentStandardPrescriptionRightColumn';
